import { documentTypesLocales as libDocumentTypesLocales } from '@shinetools/shine-start-library';
import LocalizedStrings from 'localized-strings';

import { ShineStartDocument } from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import useShineStartDocumentMutation from 'features/Onboarding/common/useShineStartDocumentMutation';
import Header from 'features/Onboarding/components/Header';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import OBStickyButton from 'features/Onboarding/components/OBStickyButton/OBStickyButton';
import DisplayOrUploadDoc from 'features/Onboarding/legacy/components/DisplayOrUploadDoc';
import { getUploadShineStartDocumentFunction } from 'features/Storage/upload';

import locales from './locales';
import { UploadSectionWrapper } from './styles';

const documentTypesLocales = new LocalizedStrings(libDocumentTypesLocales);

interface HandwrittenIdentityUploadProps {
  onNext: () => void;
  document: ShineStartDocument;
}
const HandwrittenIdentityUpload = asBentoPage<HandwrittenIdentityUploadProps>(
  ({ document, Layout, onNext, onPrev }) => {
    const { shineStartDocumentId, shineStartId } = document;

    const { deleteDocument, isDeletingDocument, updateDocument } =
      useShineStartDocumentMutation({
        shineStartDocumentId,
        shineStartId,
      });

    const existingDocumentUrl = document.url || undefined;

    return (
      <Layout nav={<OBNavigation onPrev={onPrev} paddingBottom="space-24" />}>
        <Header description={locales.description} title={locales.title} />

        <UploadSectionWrapper>
          <DisplayOrUploadDoc
            existingDocumentUrl={existingDocumentUrl}
            isDeletingExistingDocument={isDeletingDocument}
            locales={{
              uploadedDocumentName:
                documentTypesLocales.PROOF_OF_IDENTITY_HAND_WRITTEN.label,
              uploadFailureMessage: locales.uploadFailureMessage,
              uploadFormBrowse: locales.uploadFormBrowse,
              uploadFormDragDrop: locales.uploadFormDragDrop,
            }}
            onDeleteExistingDocument={deleteDocument}
            onSuccessfulUpload={({ bucketName, fileRef, url }) =>
              updateDocument({
                firebaseBucket: bucketName,
                firebaseRef: fileRef,
                url,
              })
            }
            uploadFile={getUploadShineStartDocumentFunction(shineStartId)}
          />
        </UploadSectionWrapper>

        <OBStickyButton
          isDisabled={existingDocumentUrl === undefined || isDeletingDocument}
          onClick={onNext}
        >
          {locales.ctaContinue}
        </OBStickyButton>
      </Layout>
    );
  },
);

export default HandwrittenIdentityUpload;
